import { createAsyncThunk } from '@reduxjs/toolkit'
import { BomItemController } from 'controllers/Project/BomItemController'
import { BomItemPointer } from 'model/Project/BomItemPointer'
import { ResourceSummaryDto } from 'services/APIs/InternalAPI/internal-api.contracts'
import { ShowException } from 'store/Application/appActions'
import { RootAppState } from 'store/configureStore'
import { getContext } from 'store/getContext'
import { newProjectActions } from '../projectReducer'
import { fetchProject } from './fetchProject'

const emptyGuid = '00000000-0000-0000-0000-000000000000'

export const saveBomItemResource = createAsyncThunk<
  void,
  {
    bomItemPointersAndActivityId: {
      bomItemPointer: BomItemPointer
      activityId?: string
    }[]
    resource: ResourceSummaryDto
    controllerInstance: BomItemController
  },
  { state: RootAppState }
>(
  'bom/save-resource',
  async (
    { bomItemPointersAndActivityId, resource, controllerInstance },
    thunkAPI,
  ) => {
    const { projectId } = getContext(thunkAPI.getState)
    const state = thunkAPI.getState()

    try {
      // dont change the resource if user selected (auto) option
      if (resource.id !== emptyGuid) {
        bomItemPointersAndActivityId.forEach(
          ({ bomItemPointer, activityId }) => {
            if (activityId) {
              thunkAPI.dispatch(
                newProjectActions.setBomItemWorkingSteps({
                  bomItemPointer: bomItemPointer,
                  activityId: activityId,
                  workingStep: {
                    resource: {
                      ...resource,
                    },
                  },
                }),
              )
            }
          },
        )
      }

      await controllerInstance.SetBomItemResourceBatch(
        bomItemPointersAndActivityId.map((x) => ({
          boMItemId: x.bomItemPointer.id,
          activityId: x.activityId,
        })),
        resource.id,
      )
    } catch (err) {
      thunkAPI.dispatch(fetchProject({ projectId: projectId }))
      ShowException('project', err)
    }
  },
)
